import React, { useEffect, useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage"; // helper function we'll create
import Button from "components/button";

export default function PhotoUploader({ uploadHanlder, modalOpen }) {
  const webcamRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Capture photo from webcam
  const capture = () => {
    const image = webcamRef.current.getScreenshot();
    setImageSrc(image);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      // Convert to blob for backend
      const blob = await (await fetch(croppedImage)).blob();

      if(uploadHanlder) uploadHanlder(blob);

    } catch (err) {
      console.error(err);
    }
  };

  const stopCamera = () => {
    if (webcamRef.current) {
      const video = webcamRef.current.video;
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach((track) => track.stop());
      }
    }
  };

  useEffect(() => {
    return () => stopCamera();
  }, []);

  // Also stop camera if modal is closed
  useEffect(() => {
    if (!modalOpen) {
      stopCamera();
    }
  }, [modalOpen]);

  return (
    <div>
      {!imageSrc ? (
        <div className="vatar-uploader">
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode: "user" }}
          />
          <Button extra="mt-2" onClick={capture}>Capture Photo</Button>
        </div>
      ) : (
        <>
        <div style={{ position: "relative", width: "200px", height: "200px" }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1} // square crop
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
          
        </div>
          <div className="mt-2 flex gap-4 justify-center">
            <Button onClick={() => setImageSrc(null)}>Retake</Button>
            <Button onClick={saveCroppedImage}>Save</Button>
          </div>
        </>
      )}
    </div>
  );
}
